import { render, staticRenderFns } from "./cr013a.vue?vue&type=template&id=08412caa"
import script from "./cr013a.vue?vue&type=script&lang=js"
export * from "./cr013a.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports